import liff from '@line/liff';

const LIFF_ID = import.meta.env.VITE_LIFF_ID || '';

let initialized = false;

/**
 * Initialize LIFF SDK
 */
export async function initLiff(): Promise<void> {
  if (initialized) return;

  console.log('Initializing LIFF with ID:', LIFF_ID);
  if (!LIFF_ID) {
    console.warn('LIFF_ID not configured');
    return;
  }

  await liff.init({ liffId: LIFF_ID });
  initialized = true;

  console.log('LIFF initialized', {
    isLoggedIn: liff.isLoggedIn(),
    isInClient: liff.isInClient(),
    os: liff.getOS(),
  });
}

/**
 * Check if user is logged in
 */
export function isLoggedIn(): boolean {
  return liff.isLoggedIn();
}

/**
 * Login to LINE
 */
export function login(): void {
  liff.login();
}

/**
 * Logout from LINE
 */
export function logout(): void {
  liff.logout();
}

/**
 * Get LIFF ID token for API authentication
 */
export function getIdToken(): string | null {
  return liff.getIDToken();
}

/**
 * Get user profile from LIFF
 */
export async function getProfile(): Promise<{
  userId: string;
  displayName: string;
  pictureUrl?: string;
}> {
  return liff.getProfile();
}

/**
 * Check if running inside LINE app
 */
export function isInClient(): boolean {
  return liff.isInClient();
}

/**
 * Close LIFF window (only works in LINE app)
 */
export function closeWindow(): void {
  if (liff.isInClient()) {
    liff.closeWindow();
  }
}

/**
 * Open URL in external browser
 */
export function openWindow(url: string, external: boolean = false): void {
  liff.openWindow({ url, external });
}

/**
 * Share target picker (send message to chat)
 */
export async function shareMessage(messages: unknown[]): Promise<void> {
  if (!liff.isApiAvailable('shareTargetPicker')) {
    throw new Error('Share target picker not available');
  }
  await liff.shareTargetPicker(messages as any);
}
